module.exports = __webpack_public_path__ + "img/finger-food-1.1f07ede5.jpg";